// import Pages from 'layouts/Pages';
import Dashboard from 'layouts/Dashboard';
import CovidTables from 'views/Covid/Tables';
import CovidCharts from 'views/Covid/Charts';
import CovidMap from 'views/Covid/Map';
import CovidDashboard from 'views/Covid/Dashboard';

const indexRoutes = [
  { path: '/covid-dashboard', component: CovidDashboard },
  { path: '/covid-charts', component: CovidCharts },
  { path: '/covid-resources', component: CovidTables },
  { path: '/covid-map', component: CovidMap },
  { path: '/', component: Dashboard }
];

export default indexRoutes;

// WEBPACK FOOTER //
// ./src/routes/index
